import Form from 'react-bootstrap/Form';
import Accordion from 'react-bootstrap/Accordion';

function SupporterInformationSection({
  values,
  handleChange,
  handleBlur,
  errors,
  touched,
}) {
  return (
    <>
      <Accordion className='mt-4'>
        <Accordion.Item eventKey='0'>
          <Accordion.Header>Anmälare (frivilligt)</Accordion.Header>
          <Accordion.Body>
            <Form.Group controlId='supporter.name' className='mt-2'>
              <Form.Label>Namn anmälare</Form.Label>
              <Form.Control
                type='text'
                value={values?.supporter?.name}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder='Ange namn på anmälare'
              />
            </Form.Group>
            <Form.Group controlId='supporter.licens' className='mt-2'>
              <Form.Label>Licens</Form.Label>
              <Form.Control
                type='number'
                value={values?.supporter?.licens}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder='Ange licens för anmälare'
              />
            </Form.Group>
            <Form.Group controlId='supporter.street' className='mt-2'>
              <Form.Label>Gatuadress anmälare</Form.Label>
              <Form.Control
                type='text'
                value={values?.supporter?.street}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder='Ange gatuadress för anmälare'
              />
            </Form.Group>
            <Form.Group controlId='supporter.zipCode' className='mt-2'>
              <Form.Label>Postnummer anmälare</Form.Label>
              <Form.Control
                type='text'
                value={values?.supporter?.zipCode}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder='Ange postnummer för anmälare'
              />
            </Form.Group>
            <Form.Group controlId='supporter.city' className='mt-2'>
              <Form.Label>Postort anmälare</Form.Label>
              <Form.Control
                type='text'
                value={values?.supporter?.city}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder='Ange postort för anmälare'
              />
            </Form.Group>
            <Form.Group controlId='supporter.phoneNumber' className='mt-2'>
              <Form.Label>Telefonnummer anmälare</Form.Label>
              <Form.Control
                type='text'
                value={values?.supporter?.phoneNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder='Ange telefon för anmälare'
              />
            </Form.Group>
            <Form.Group controlId='supporter.email' className='mt-2'>
              <Form.Label>E-post anmälare</Form.Label>
              <Form.Control
                type='text'
                value={values?.supporter?.email}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder='Ange e-post för anmälare'
              />
            </Form.Group>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
}

export default SupporterInformationSection;
